import React from 'react';
import { Box, Grid } from '../../../node_modules/@mui/material/index';
import DistributorReportController from 'pages/Controller/DistributorReportController';
import Loader from 'components/Loader';
import ReportsTabs from 'utils/ReportsTabs';

const DistributorReports = () => {
  const { cloading, currentFY, previousFY, outstanding, sales,targetsales, categoryComp } = DistributorReportController();

  return (
    <div className="bg" style={{ display: 'block' }}>
      {cloading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please wait, fetching reports...</span>
        </div>
      ) : null}
      <div className="cutrange">
        <span className="font20" style={{ fontWeight: 'bold' }}>
          KPI Reports
        </span>
      </div>

      <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', px: { xs: 1, sm: 2 } }}>
        <Grid  container spacing={3}>
          <Grid item xs={12}>
            <ReportsTabs outstanding={outstanding} sales={sales} categoryComp={categoryComp} targetsales={targetsales} currentFY={currentFY} previousFY={previousFY} />
          </Grid>
        </Grid>
      </Box>
      {/* <div style={{marginTop:'10px'}}>
               
            </div> */}
    </div>
  );
};

export default DistributorReports;
